module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ec-Gd.a167a41d.png";